export const navData = [
  {
    label: "Oferta",
    url: "/oferta/",
  },
  {
    label: "Cennik",
    url: "/cennik/",
  },
  {
    label: "O nas",
    url: "/o-nas/",
  },
  {
    label: "Testy i badania",
    url: "/testy-psychologiczne/",
  },
  {
    label: "Zespół",
    url: "/zespol/",
  },
  {
    label: "Galeria",
    url: "/galeria/",
  },
  {
    label: "Blog",
    url: "/blog/",
  },
  {
    label: "Kontakt",
    url: "/kontakt/",
  },
];
